import { AppBar, Tab, Tabs, Toolbar, Typography } from "@mui/material";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { RouteProps } from "./DashboardPageLayout";

export default function DashboardPageHeader({ pageName, childTabs }: RouteProps) {
	const { tabRoute } = useParams();
	const activeTab = childTabs?.length ? childTabs.find((tab) => tab.tabRoute === tabRoute) || childTabs[0] : null;

	return (
		<>
			<AppBar component="div" color="primary" position="static" elevation={0} sx={{ zIndex: 0 }}>
				<Toolbar>
					<Typography color="inherit" variant="h4" component="h1">
						{pageName}
					</Typography>
				</Toolbar>
			</AppBar>
			{childTabs?.length && (
				<AppBar component="div" position="static" elevation={0} sx={{ zIndex: 0 }}>
					<Tabs value={activeTab?.tabRoute} textColor="inherit">
						{childTabs.map((child) => (
							<Tab
								key={child.tabRoute}
								label={child.label || child.tabRoute}
								value={child.tabRoute}
								component={Link}
								to={child.tabRoute}
								replace={true}
							/>
						))}
					</Tabs>
				</AppBar>
			)}
		</>
	);
}
